import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1848c114"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "option__icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 22L6.34 16.4309C3.22 13.361 3.22 8.37235 6.34 5.30243C7.9 3.76748 9.95 3 12 3C14.05 3 16.1 3.76748 17.66 5.30243C20.78 8.37235 20.78 13.361 17.66 16.4309L12 22ZM12.002 13.5576C13.6588 13.5576 15.002 12.236 15.002 10.6058C15.002 8.97552 13.6588 7.65394 12.002 7.65394C10.3451 7.65394 9.00195 8.97552 9.00195 10.6058C9.00195 12.236 10.3451 13.5576 12.002 13.5576Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_3 = { class: "option__name ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["TypeSwitcher", _ctx.typeSwitcherClasses])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.id,
        class: _normalizeClass(["TypeSwitcher__option", {
                'option--selected': _ctx.isOptionSelected(option),
                'option--disabled': _ctx.isOptionDisabled(option) 
            }]),
        onClick: ($event: any) => (_ctx.onClick(option))
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(option.name), 1)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}